import styled from 'styled-components';

const Wrapper = styled.div`
  margin-top: 18px;
  height: calc(100% - 104px);
  & > * {
    margin-bottom: 20px;
  }
  & > :last-child {
    margin-bottom: 0;
  }
`;
Wrapper.displayName = 'Wrapper';

export default Wrapper;
